import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import LegalLayout from './LegalLayout';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Oeffentliche Ansicht eines Zustimmungsdokuments (Bildrechte, KI, Abrechnung) in der aktuellen Fassung.
 * Inhalt kommt aus sf_consent_documents (Admin pflegt Text und Version). ?version=N zeigt eine aeltere Fassung.
 */
export default function EinwilligungPage() {
    const { key } = useParams();
    const [doc, setDoc] = useState(null);
    const [error, setError] = useState('');
    useEffect(() => {
        const wanted = new URLSearchParams(window.location.search).get('version');
        axios.get(`${API_URL}/api/sf/consents/documents/${key}/versions`).then(r => {
            const all = [r.data.current, ...(r.data.previous || [])];
            const pick = wanted ? all.find(d => String(d.version) === String(wanted)) : r.data.current;
            if (!pick) setError('Diese Fassung gibt es nicht.');
            else setDoc(pick);
        }).catch(() => setError('Dokument nicht gefunden.'));
    }, [key]);
    if (error) return <LegalLayout title="Einwilligung"><p>{error}</p></LegalLayout>;
    if (!doc) return <LegalLayout title="Einwilligung"><p>Lädt …</p></LegalLayout>;
    return (
        <LegalLayout title={doc.title} updated={`Fassung ${doc.version}, gültig ab ${doc.valid_from || '–'}`}>
            {doc.archived_at && <p className="text-amber-500 text-sm">Dies ist eine ältere Fassung. Die aktuelle Fassung findest du ohne Versionsangabe im Link.</p>}
            <div dangerouslySetInnerHTML={{ __html: doc.body || '' }} />
            <p className="text-xs text-muted-foreground pt-6">The Guardians of Social Media GmbH · Diese Einwilligung kann jederzeit mit Wirkung für die Zukunft im Social-Face-Portal unter „Profil“ widerrufen werden.</p>
        </LegalLayout>
    );
}
